module.exports = __webpack_public_path__ + "assets/img/mail@3x.f0b13360.png";